import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Switch from "react-switch";
// css
import styles from "./ClientDetail.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";

// img
import formIcn from "../../../../../Assets/images/formIcn.svg";
import { useFundingSourceDetailsQuery } from "store/services/fundingSource";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { ADD_FUNDING_SOURCE } from "config/paths";

const PCFundingSourceDetail = () => {

  const { id: fundingSourceId } = useParams();
  const navigate = useNavigate();

  const [checked, setChecked] = useState(false);
  const [tableRow, setTableRow] = useState(false);

  const handleChange = (checked) => {
    setChecked(checked);
  };

  const { data: fundingDetail, isLoading } = useFundingSourceDetailsQuery(fundingSourceId);

  return (
    <>
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid={true}>
          {
            isLoading ? <LoadingIndicator /> :
              <Row>
                <Col
                  lg="6"
                  className=""
                  style={{ borderRight: "1px solid #3da0aa4f" }}
                >
                  <Row>
                    <Col lg="12" className="my-3">
                      <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                        <div className="left">
                          <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                            <li className="">
                              <Link
                                className="themeBlue fw-sbold"
                                style={{ textDecoration: "underline" }}
                                to="/manage-private-clients/funding-sources/"
                              >
                                Funding Source
                              </Link>
                            </li>
                            <li className="">
                              <h5 className="m-0 fw-bold themeBlue">/ Details</h5>
                            </li>
                          </ul>
                        </div>
                        <div className="right">
                          <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                            <li className="">
                              <Button
                                className="d-flex align-items-center rounded-pill justify-content-center btn-sm"
                                variant="outline-success"
                                onClick={() => navigate(ADD_FUNDING_SOURCE, { state: { id: fundingSourceId } })}
                              >
                                <span className="icn me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                  >
                                    <mask
                                      id="mask0_0_2439"
                                      style={{ maskType: "alpha" }}
                                      maskUnits="userSpaceOnUse"
                                      x="0"
                                      y="0"
                                      width="18"
                                      height="18"
                                    >
                                      <rect width="18" height="18" fill="#D9D9D9" />
                                    </mask>
                                    <g mask="url(#mask0_0_2439)">
                                      <path
                                        d="M1.5 17.9997V15.7497H16.5V17.9997H1.5ZM4.5 12.3099H5.42737L11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L4.5 11.3825V12.3099ZM3.375 13.4349V10.9036L11.7823 2.50792C11.8909 2.3993 12.0142 2.31711 12.1523 2.26136C12.2901 2.20561 12.4336 2.17773 12.5828 2.17773C12.732 2.17773 12.8765 2.20561 13.0163 2.26136C13.156 2.31711 13.2841 2.40317 13.4004 2.51955L14.3019 3.43249C14.4183 3.54111 14.5024 3.66555 14.5543 3.8058C14.6062 3.94592 14.6321 4.0908 14.6321 4.24042C14.6321 4.38067 14.6058 4.52011 14.5532 4.65873C14.5006 4.79748 14.4168 4.9243 14.3019 5.03917L5.90625 13.4349H3.375ZM11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L11.6524 6.0963Z"
                                        fill="currentColor"
                                      />
                                    </g>
                                  </svg>
                                </span>
                                Edit
                              </Button>
                            </li>
                            <li className="">
                              <Button
                                className="d-flex align-items-center rounded-pill justify-content-center btn-sm"
                                variant="outline-danger"
                              >
                                <span className="icn me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="14"
                                    viewBox="0 0 12 14"
                                    fill="none"
                                  >
                                    <path
                                      d="M2.48081 13.3753C2.10681 13.3753 1.78731 13.2429 1.52231 12.978C1.25744 12.713 1.125 12.3935 1.125 12.0195V2.50029H0.375V1.37529H3.75V0.711914H8.25V1.37529H11.625V2.50029H10.875V12.0195C10.875 12.3984 10.7438 12.719 10.4813 12.9815C10.2188 13.244 9.89806 13.3753 9.51919 13.3753H2.48081ZM9.75 2.50029H2.25V12.0195C2.25 12.0869 2.27162 12.1422 2.31487 12.1854C2.35812 12.2287 2.41344 12.2503 2.48081 12.2503H9.51919C9.57694 12.2503 9.62981 12.2262 9.67781 12.1781C9.72594 12.1301 9.75 12.0772 9.75 12.0195V2.50029ZM4.053 10.7503H5.17781V4.00029H4.053V10.7503ZM6.82219 10.7503H7.947V4.00029H6.82219V10.7503Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </span>
                                Archive
                              </Button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </Col>
                    <Col lg="12" className="my-3">
                      <div className="top d-flex align-items-center justify-content-between gap-10">
                        <div className="left d-flex align-items-center gap-10">
                          <div
                            className="igmWrp flex-shrink-0 d-flex themeBlue fw-sbold align-items-center justify-content-center rounded-circle"
                            style={{ height: 35, width: 35, background: "#DBDBDB" }}
                          >
                            JD
                          </div>
                          <div className="content">
                            <h6 className="m-0 themeBlue fw-sbold">John Deo</h6>
                          </div>
                        </div>
                        <div className="right">
                          <p className="m-0 rounded-pill px-3 violetStatus">
                            Private
                          </p>
                        </div>
                      </div>
                      <Row>
                        <Col md="4" sm="6" className="my-1">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6
                              className="m-0 themeBlue fw-bold"
                              style={{ fontSize: 14 }}
                            >
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              DOB
                            </h6>
                            <p className="m-0 themeBlue pt-2">22/05/2022</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-1">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6
                              className="m-0 themeBlue fw-bold"
                              style={{ fontSize: 14 }}
                            >
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Gender
                            </h6>
                            <p className="m-0 themeBlue pt-2">Male</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-1">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6
                              className="m-0 themeBlue fw-bold"
                              style={{ fontSize: 14 }}
                            >
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Caseworker Name
                            </h6>
                            <p className="m-0 themeBlue pt-2">Nick</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-1">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6
                              className="m-0 themeBlue fw-bold"
                              style={{ fontSize: 14 }}
                            >
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Contract Start Date
                            </h6>
                            <p className="m-0 themeBlue pt-2">22/02/23</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-1">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6
                              className="m-0 themeBlue fw-bold"
                              style={{ fontSize: 14 }}
                            >
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Contract End Date
                            </h6>
                            <p className="m-0 themeBlue pt-2">22/04/23</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-1">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6
                              className="m-0 themeBlue fw-bold"
                              style={{ fontSize: 14 }}
                            >
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Funding Source
                            </h6>
                            <p className="m-0 themeBlue pt-2">22/04/23</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-1">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              MDT Assessment
                            </h6>
                            <div className="content d-flex align-items-center">
                              <p className="m-0 text-muted mx-1">Off</p>
                              <Switch
                                uncheckedIcon={""}
                                checkedIcon={""}
                                onHandleColor={"#A3DF00"}
                                offHandleColor={"#A3DF00"}
                                onColor={"#E6E6E6"}
                                offColor={"#E6E6E6"}
                                height={18}
                                width={40}
                                onChange={handleChange}
                                checked={checked}
                              />
                              <p className="m-0 text-muted mx-1">On</p>
                            </div>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-1">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6
                              className="m-0 themeBlue fw-bold"
                              style={{ fontSize: 14 }}
                            >
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Parent 1 Name
                            </h6>
                            <p className="m-0 themeBlue pt-2">smith</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-1">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6
                              className="m-0 themeBlue fw-bold"
                              style={{ fontSize: 14 }}
                            >
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Parent 1 Email
                            </h6>
                            <p className="m-0 themeBlue pt-2">smith@gmail.com</p>
                          </div>
                        </Col>
                        <Col md="4" sm="6" className="my-1">
                          <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                            <h6
                              className="m-0 themeBlue fw-bold"
                              style={{ fontSize: 14 }}
                            >
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Parent 1 Phone
                            </h6>
                            <p className="m-0 themeBlue pt-2">+1 234567890</p>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg="12" className="my-3">
                      <h6 className="m-0 themeBlue fw-sbold">Service Detail</h6>
                      <p className="m-0 themeBlue">
                        Lorem Ipsum is simply dummy text of the printing and
                        typesetting industry. Lorem Ipsum has been the industry's
                        standard dummy text ever since the 1500s
                      </p>
                    </Col>
                  </Row>
                </Col>
                <Col lg="6" className="">
                  <Row>
                    <Col lg="12" className="my-2">
                      <div className="d-flex align-items-center justify-content-between flex-wrap gap-10">
                        <h6 className="m-0 themeBlue fw-bold">
                          Track number of sessions
                        </h6>
                        <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                          <li className="">
                            <Button className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent">
                              <span className="icn me-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="9"
                                  height="13"
                                  viewBox="0 0 9 13"
                                  fill="none"
                                >
                                  <path
                                    d="M0.459961 0.119792V1.67977H8.25985V0.119792H0.459961ZM3.57992 3.23975V9.61615L1.55194 7.60768L0.459961 8.69967L4.3599 12.5996L8.25985 8.69967L7.16786 7.60768L5.13989 9.61615V3.23975H3.57992Z"
                                    fill="#1C1B1F"
                                  />
                                </svg>
                              </span>{" "}
                              Upload File
                            </Button>
                          </li>
                          <li className="">
                            <Button className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent">
                              <span className="icn me-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="9"
                                  height="13"
                                  viewBox="0 0 9 13"
                                  fill="none"
                                >
                                  <path
                                    d="M0.459961 12.5999V11.04H8.25985V12.5999H0.459961ZM3.57992 9.47998V3.10357L1.55194 5.11204L0.459961 4.02006L4.3599 0.120117L8.25985 4.02006L7.16786 5.11204L5.13989 3.10357V9.47998H3.57992Z"
                                    fill="#1C1B1F"
                                  />
                                </svg>
                              </span>{" "}
                              Download File
                            </Button>
                          </li>
                        </ul>
                      </div>
                    </Col>
                    <Col lg="12" className="my-2">
                      <div
                        className={`${styles.tableResponsive} tableResponsive table-responsive mb-3 pb-0`}
                      >
                        <table className={`${styles.table} table mb-0`}>
                          <thead>
                            <tr className="">
                              <th className="text-dark fw-bold border-0 bg-transparent">
                                Discipline
                              </th>
                              <th className="text-dark fw-bold border-0 bg-transparent">
                                Attended Session
                              </th>
                              <th className="text-dark fw-bold border-0 bg-transparent">
                                Total Session
                              </th>
                              <th className="text-dark fw-bold border-0 bg-transparent"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr onClick={() => setTableRow(!tableRow)}>
                              <td className="">SLP</td>
                              <td className="">4</td>
                              <td className="">6</td>
                              <td className="">
                                <Button
                                  className="border-0 p-0"
                                  variant="transparent"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                  >
                                    <path
                                      d="M10 7.26925L6.4615 10.8078L13.5385 10.8078L10 7.26925ZM9.99825 0.500001C11.3122 0.500001 12.5473 0.749333 13.7035 1.248C14.8597 1.74667 15.8653 2.42342 16.7205 3.27825C17.5757 4.13308 18.2527 5.13833 18.7517 6.294C19.2506 7.44967 19.5 8.68442 19.5 9.99825C19.5 11.3123 19.2507 12.5473 18.752 13.7035C18.2533 14.8597 17.5766 15.8653 16.7217 16.7205C15.8669 17.5757 14.8617 18.2528 13.706 18.7518C12.5503 19.2506 11.3156 19.5 10.0017 19.5C8.68775 19.5 7.45267 19.2507 6.2965 18.752C5.14033 18.2533 4.13467 17.5766 3.2795 16.7218C2.42433 15.8669 1.74725 14.8617 1.24825 13.706C0.749416 12.5503 0.499999 11.3156 0.499999 10.0018C0.499999 8.68775 0.749331 7.45267 1.248 6.2965C1.74666 5.14033 2.42341 4.13467 3.27825 3.2795C4.13308 2.42433 5.13833 1.74725 6.294 1.24825C7.44966 0.749417 8.68442 0.500001 9.99825 0.500001ZM10 2C7.76666 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2Z"
                                      fill="#071E3E"
                                    />
                                  </svg>
                                </Button>
                              </td>
                            </tr>
                            {tableRow && (
                              <tr>
                                <td colSpan={4} className="p-0 border-0">
                                  <div
                                    className={`${styles.tableResponsive} tableResponsive table-responsive mb-0 pb-0`}
                                  >
                                    <table className={`${styles.table} table mb-0`}>
                                      <thead>
                                        <tr className="">
                                          <th className="text-dark fw-bold bg-transparent">
                                            Date
                                          </th>
                                          <th className="text-dark fw-bold bg-transparent">
                                            Present
                                          </th>
                                          <th className="text-dark fw-bold bg-transparent">
                                            Absent
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td className="border-0 p-2">
                                            11/06/2024
                                          </td>
                                          <td className="border-0 p-2">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="20"
                                              height="20"
                                              viewBox="0 0 20 20"
                                              fill="none"
                                            >
                                              <path
                                                d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
                                                fill="#16BF12"
                                              />
                                            </svg>
                                          </td>
                                          <td className="border-0 p-2"></td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Col>
                    <Col lg="12" className="my-2">
                      <h5 className="m-0 themeBlue fw-bold pb-2">Attachments:</h5>
                      <div
                        className={`${styles.tableResponsive} tableResponsive table-responsive mb-3 pb-0`}
                      >
                        <table className={`${styles.table} table mb-0`}>
                          <tbody>
                            <tr>
                              <td className="">
                                <div className="d-flex align-items-center gap-10">
                                  <span className="icn flex-shrink-0">
                                    <img
                                      src={formIcn}
                                      alt=""
                                      className="img-fluid"
                                    />
                                  </span>
                                  <p className="m-0">Consent Form</p>
                                </div>
                              </td>
                              <td className="">OT</td>
                              <td className="">22/05/2024</td>
                              <td className="">
                                <div className="d-flex align-items-center gap-10">
                                  <Button
                                    style={{ minWidth: "unset " }}
                                    className="d-flex align-items-center justify-content-center commonBtn h-auto"
                                  >
                                    <span className="icn me-1">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="11"
                                        viewBox="0 0 16 11"
                                        fill="none"
                                      >
                                        <path
                                          d="M8.00162 8.68275C8.8515 8.68275 9.57331 8.38531 10.1671 7.79044C10.7608 7.19556 11.0577 6.47319 11.0577 5.62331C11.0577 4.77344 10.7602 4.05163 10.1654 3.45787C9.5705 2.86412 8.84812 2.56725 7.99825 2.56725C7.14837 2.56725 6.42656 2.86469 5.83281 3.45956C5.23906 4.05444 4.94218 4.77681 4.94218 5.62669C4.94218 6.47656 5.23962 7.19837 5.8345 7.79212C6.42937 8.38587 7.15175 8.68275 8.00162 8.68275ZM7.99993 7.65C7.43743 7.65 6.95931 7.45313 6.56556 7.05938C6.17181 6.66563 5.97493 6.1875 5.97493 5.625C5.97493 5.0625 6.17181 4.58437 6.56556 4.19063C6.95931 3.79688 7.43743 3.6 7.99993 3.6C8.56243 3.6 9.04056 3.79688 9.43431 4.19063C9.82806 4.58437 10.0249 5.0625 10.0249 5.625C10.0249 6.1875 9.82806 6.66563 9.43431 7.05938C9.04056 7.45313 8.56243 7.65 7.99993 7.65ZM8.00087 10.875C6.27625 10.875 4.70481 10.3993 3.28656 9.44775C1.86831 8.49638 0.824059 7.22213 0.153809 5.625C0.824059 4.02787 1.86793 2.75362 3.28543 1.80225C4.70306 0.85075 6.27425 0.375 7.999 0.375C9.72362 0.375 11.2951 0.85075 12.7133 1.80225C14.1316 2.75362 15.1758 4.02787 15.8461 5.625C15.1758 7.22213 14.1319 8.49638 12.7144 9.44775C11.2968 10.3993 9.72562 10.875 8.00087 10.875ZM7.99993 9.75C9.41243 9.75 10.7093 9.37813 11.8906 8.63437C13.0718 7.89062 13.9749 6.8875 14.5999 5.625C13.9749 4.3625 13.0718 3.35938 11.8906 2.61562C10.7093 1.87187 9.41243 1.5 7.99993 1.5C6.58743 1.5 5.29056 1.87187 4.10931 2.61562C2.92806 3.35938 2.02493 4.3625 1.39993 5.625C2.02493 6.8875 2.92806 7.89062 4.10931 8.63437C5.29056 9.37813 6.58743 9.75 7.99993 9.75Z"
                                          fill="white"
                                        />
                                      </svg>
                                    </span>
                                    View
                                  </Button>
                                  <Button
                                    className="border-0 p-0"
                                    variant="transparent"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      fill="none"
                                    >
                                      <path
                                        d="M8 12L3 7L4.4 5.55L7 8.15V0H9V8.15L11.6 5.55L13 7L8 12ZM2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V11H2V14H14V11H16V14C16 14.55 15.8042 15.0208 15.4125 15.4125C15.0208 15.8042 14.55 16 14 16H2Z"
                                        fill="#071E3E"
                                      />
                                    </svg>
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
          }
        </Container >
      </section >
    </>
  );
};

export default PCFundingSourceDetail;
